import { ZoomMeeting, CustomSelect } from '../models';

export function localDate(Meeting: ZoomMeeting): string {

  // défini la timezone locale
  const rightNow: Date = new Date();
  const operator: string = String(rightNow).includes('+') ? '+' : String(rightNow).includes('-') ? '-' : '';
  const GMT: string = operator === '' ? '' : String(String(rightNow).split(operator)[1]).split(' ')[0];

  // déclare la date sans la timezone
  const _start_time: Array<string> = new Date(Meeting.start_time).toString().split(' ');

  // modifie la date par rapport à la timezone
  const _date_result: Date = new Date(`${_start_time[1]} ${_start_time[2]}, ${_start_time[3]} ${_start_time[4]} ${operator}${GMT}`);

  // formalise la date pour zoom (string : yyyy-MM-ddThh:mm:00)
  const _local_month: string | number = Number(_date_result.getMonth()) + 1 < 10 ? `0${Number(_date_result.getMonth()) + 1}` : _date_result.getMonth() + 1;
  const _local_day: string | number = Number(_date_result.getDate()) < 10 ? `0${Number(_date_result.getDate())}` : _date_result.getDate();
  const _local_hour: string | number = Number(_date_result.getHours()) < 10 ? `0${Number(_date_result.getHours())}` : _date_result.getHours();
  const _local_min: string | number = Number(_date_result.getMinutes()) < 10 ? `0${Number(_date_result.getMinutes())}` : _date_result.getMinutes();

  const local_date: string = `${_date_result.getFullYear()}-${_local_month}-${_local_day}T${_local_hour}:${_local_min}:00`;

  return local_date;
}


//////export function calculDate(Meeting: ZoomMeeting, agenda: ZoomModal, zoom: ZoomModal): void {
//////  const start_time_date: number = new Date(Meeting.start_time).getTime();
//////  const start_time_array: Array<string> = Meeting.start_time.replace(':', '-').replace(':', '-').replace('T', '-').replace('Z', '').split('-');
//////  const duration_time_date: Date = new Date(start_time_date + (Meeting.duration * 60000));
//////  const year: string = `${duration_time_date.getFullYear()}`;
//////  const month: string = parseTime(duration_time_date.getMonth() + 1);
//////  const day: string = parseTime(duration_time_date.getDate());
//////  const hour: string = parseTime(duration_time_date.getHours());
//////  const minute: string = parseTime(duration_time_date.getMinutes());

//////  // récupération des propriétés des dates bindé dans l'agenda, puis afectation de la valeur depuis l'api zoom
//////  if (agenda.model !== null && agenda.model !== undefined) {
//////    zoom.model = JSON.parse(JSON.stringify(agenda.model));
//////    zoom.model.Body.SelectedGroupsList.forEach((input: PropertyGroup) => {
//////      input.DataList.forEach((element: PropertyData) => {
//////        if (element.MainElementList[0].Mask === 'DATEDEBUT') {
//////          element.MainElementList[0].Value = `${start_time_array[2]}/${start_time_array[1]}/${start_time_array[0]}`;
//////          element.MainElementList[1].Value = `${start_time_array[3]}`;
//////          element.MainElementList[2].Value = `${start_time_array[4]}`;
//////        } else if (element.MainElementList[0].Mask === 'DATEFIN') {
//////          element.MainElementList[0].Value = `${day}/${month}/${year}`;
//////          element.MainElementList[1].Value = `${hour}`;
//////          element.MainElementList[2].Value = `${minute}`;
//////        }
//////        if (element.MainElementList[0].Mask === 'DATEDEBUT' || element.MainElementList[0].Mask === 'DATEFIN') {

//////          element.MainElementList.forEach((value: HtmlBase) => {
//////            value.SelectOptionsList.forEach((choice: QueovalItem) => {
//////              if (choice.Value === value.Value) {
//////                choice.Selected = true;
//////              } else {
//////                choice.Selected = false;
//////              }
//////            });
//////          });
//////        }
//////      });
//////    });
//////  }
//////  zoom.dateDebut = JSON.parse(JSON.stringify(agenda.dateDebut));
//////  zoom.dateDebut.MainElementList[0].Value = `${start_time_array[2]}/${start_time_array[1]}/${start_time_array[0]}`;
//////  zoom.dateDebut.MainElementList[1].Value = `${start_time_array[3]}`;
//////  zoom.dateDebut.MainElementList[2].Value = `${start_time_array[4]}`;

//////  zoom.dateFin = JSON.parse(JSON.stringify(agenda.dateFin));
//////  zoom.dateFin.MainElementList[0].Value = `${day}/${month}/${year}`;
//////  zoom.dateFin.MainElementList[1].Value = `${hour}`;
//////  zoom.dateFin.MainElementList[2].Value = `${minute}`;
//////}

//////export function getDates(properties: ZoomModal): void {
//////  properties.model.Body.SelectedGroupsList.forEach((input: PropertyGroup) => {
//////    input.DataList.forEach((element: PropertyData) => {
//////      if (element.MainElementList[0].Mask === 'DATEDEBUT') {
//////        properties.dateDebut = element;
//////      } else if (element.MainElementList[0].Mask === 'DATEFIN') {
//////        properties.dateFin = element;
//////        return;
//////      }
//////    });
//////  });
//////}

//////export function selectTime(properties: ZoomModal): { [index: string]: string } {
//////  let result: { [index: string]: string };
//////  let start_time_hour: string = '';
//////  properties.dateDebut.MainElementList[1].SelectOptionsList.forEach((mainElement: QueovalItem) => {
//////    if (mainElement.Selected === true) {
//////      start_time_hour = mainElement.Value;
//////      return;
//////    }
//////  });

//////  let start_time_min: string = '';
//////  properties.dateDebut.MainElementList[2].SelectOptionsList.forEach((mainElement: QueovalItem) => {
//////    if (mainElement.Selected === true) {
//////      start_time_min = mainElement.Value;
//////      return;
//////    }
//////  });

//////  let end_Time_hour: string = '';
//////  properties.dateFin.MainElementList[1].SelectOptionsList.forEach((mainElement: QueovalItem) => {
//////    if (mainElement.Selected === true) {
//////      end_Time_hour = mainElement.Value;
//////      return;
//////    }
//////  });

//////  let end_Time_min: string = '';
//////  properties.dateFin.MainElementList[2].SelectOptionsList.forEach((mainElement: QueovalItem) => {
//////    if (mainElement.Selected === true) {
//////      end_Time_min = mainElement.Value;
//////      return;
//////    }
//////  });

//////  result = {
//////    'start_time_hour': start_time_hour,
//////    'start_time_min': start_time_min,
//////    'end_Time_hour': end_Time_hour,
//////    'end_Time_min': end_Time_min
//////  };

//////  return result;
//////}
export function selectChange(selectedValue: any, selectItem: Array<CustomSelect>): void {

  if (selectedValue && selectItem) {
    selectItem.forEach((itm: CustomSelect) => {
      itm.Selected = itm.Value.toString() === selectedValue.toString();
    });
  }
}

// export function rgbToHsv(rgv: string) {
//   const strRgv = rgv.slice(4).replace(/\ /, '').replace(/\ /, '').replace(/\)/, '').split(',');
//   const r = Number(strRgv[0]) / 255;
//   const g = Number(strRgv[1]) / 255;
//   const b = Number(strRgv[2]) / 255;

//   const max = Math.max(r, g, b);
//   const min = Math.min(r, g, b);
//   let h, s = max;
//   const v = max;
//   const d = max - min;
//   s = max === 0 ? 0 : d / max;

//   if (max === min) {
//     h = 0; // achromatic
//   } else {
//     switch (max) {
//       case r: h = (g - b) / d + (g < b ? 6 : 0); break;
//       case g: h = (b - r) / d + 2; break;
//       case b: h = (r - g) / d + 4; break;
//     }

//     h /= 6;
//   }

//   return [h, s, v];
// }
// export function hsvToRgb(h, s, v) {
//   let r, g, b;

//   const i = Math.floor(h * 6);
//   const f = h * 6 - i;
//   const p = v * (1 - s);
//   const q = v * (1 - f * s);
//   const t = v * (1 - (1 - f) * s);

//   switch (i % 6) {
//     case 0: r = v, g = t, b = p; break;
//     case 1: r = q, g = v, b = p; break;
//     case 2: r = p, g = v, b = t; break;
//     case 3: r = p, g = q, b = v; break;
//     case 4: r = t, g = p, b = v; break;
//     case 5: r = v, g = p, b = q; break;
//   }
//   const rgb = [r * 255, g * 255, b * 255];
//   return `rgb(${Math.trunc(rgb[0])},${Math.trunc(rgb[1])},${Math.trunc(rgb[2])})`;
// }

